// import axios from 'axios';
import _ from "lodash";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { Actions as ALLOWANCEACTIONS } from "../../store/actions/allowanceActions";
import { Actions as OVERTIMEACTIONS } from "../../store/actions/overtimeActions";
import { Actions as ACTIONS } from "../../store/actions/payrollActions";

import Tooltip from "@/tooltip";
import { PlusIcon, QuestionMarkCircleIcon, TrashIcon } from "@heroicons/react/20/solid";
import { addDays, differenceInCalendarDays, format, getDay, max as maxDate, min as minDate } from "date-fns";
import AllowanceRow from "./AllowanceRow";

const getWorkingDaysInPeriod = (date1, date2, workingDays) => {
	if (workingDays.length == 0) {
		return 0;
	}

	const firstDate = minDate([date1, date2]);
	const secondDate = maxDate([date1, date2]);

	const dayDifference = differenceInCalendarDays(secondDate, firstDate);
	const startDay = getDay(firstDate);
	const endDay = getDay(secondDate);

	const fullWeeks = Math.floor(dayDifference / 7);

	let daysWorked = fullWeeks * workingDays.length;

	// console.log('startDay != endDay',firstDate,startDay,endDay)

	if (startDay != endDay) {
		// there are some days we need to check if they are in our range
		let referenceDay = startDay;

		while (referenceDay != endDay) {
			// console.log('T_refDay',referenceDay,endDay)

			if (workingDays.includes(referenceDay)) {
				daysWorked++;
			}
			referenceDay++;

			if (referenceDay == 7) {
				referenceDay = 0;
			}
		}
		// console.log('refDay',referenceDay,secondDate)
		// there is one more loop to go
		if (workingDays.includes(referenceDay)) {
			daysWorked++;
		}
	} else if (startDay == endDay && dayDifference == 0) {
		// this is same day.
		if (workingDays.includes(startDay)) {
			daysWorked++;
		}
	}
	// console.log('T_',{startDay, endDay, firstDate, secondDate,daysWorked,workingDays})

	return daysWorked;
};

const SalaryRow = ({
	allowanceList,
	salary,
	index,
	ready,
	employee,
	employeeID,
	payrollSaveAllowances,
	payrollUpdateAllowance,
	clearPayslip,
	unprocessTimesheetsModal,
	payPeriodDetails,
	settings,
	processedTimesheets,
	engaged,
	terminated,
	overtimeList,
	currency,
	useExactPay,
	jurisdiction,
	...restprops
}) => {
	const hasMultipleSalaries = employee.salaries.length > 1;

	const { allowances, generating, error, occupations } = employee;

  const hasMultiRole = occupations?.length > 1;

	const {
		salaryAmount,
		payPeriodFrequencyName: salaryFrequency,
		allowances: salaryAllowances,
		overtime: salaryOvertime,
		employmentTypeName,
    roleName,
		casual,
		weeklyHours,
		start: salaryEffectiveStart,
		end: salaryEffectiveEnd,
		workingDays,
	} = salary;

	const { basicSalaryBreakdown } = employee?.payslip || {};

	let basicHoursAllowance =
		(allowances &&
			allowances.find(
				({ allowanceType, salary: salaryID }) =>
					allowanceType == 277 && ((!salaryID && index == 0) || salaryID == salary.id),
			)) ||
		false;
	const unpaidHoursAllowance =
		(allowances &&
			allowances.find(
				({ allowanceType, salary: salaryID }) =>
					allowanceType == 6558 && ((!salaryID && index == 0) || salaryID == salary.id),
			)) ||
		false;

	const basicSalaryBreakdownItem = basicSalaryBreakdown?.find(
		({ id: salaryID }) => (!salaryID && index == 0) || salaryID == salary.id,
	);
	if (!basicHoursAllowance && basicSalaryBreakdownItem) {
		basicHoursAllowance = {
			id: uuidv4(),
			allowanceType: 277,
			input: basicSalaryBreakdownItem.hoursWorked,
			amount: basicSalaryBreakdownItem.basicDue,
			disabled: !(casual == true || casual == "yes") && !hasMultipleSalaries && !useExactPay, // we need to pull through information on exact pay.
			order: 0,
			isNew: true,
		};
	}

	console.log("basicHoursAllowance", basicHoursAllowance, allowances);

	const allowancesThisSalary =
		(allowances &&
			allowances.filter(
				({ allowanceType, salary: salaryID }) =>
					allowanceType != 277 && ((!salaryID && index == 0) || salaryID == salary.id),
			)) ||
		[];

	if (!salaryEffectiveStart) {
		console.log("salaryEffectiveStart", salaryEffectiveStart);
		return null;
	}
	const salaryStart = format(new Date(salaryEffectiveStart), "yyyy-MM-dd");
	const salaryEnd = salaryEffectiveEnd && format(new Date(salaryEffectiveEnd), "yyyy-MM-dd");

	const salaryPeriodStart = salaryStart > payPeriodDetails.periodStart ? salaryStart : payPeriodDetails.periodStart;
	const salaryPeriodEnd =
		salaryEnd && salaryEnd != salaryStart && salaryEnd < payPeriodDetails.periodEnd
			? salaryEnd
			: payPeriodDetails.periodEnd;
	const workingDaysForCalculation =
		workingDays && workingDays.length > 0 ? workingDays.map((w) => parseInt(w.weekday)) : [0, 1, 2, 3, 4, 5, 6];
	const daysWorked =
		salaryPeriodEnd < salaryPeriodStart
			? 0 // this is a previous termination
			: getWorkingDaysInPeriod(new Date(salaryPeriodStart), new Date(salaryPeriodEnd), workingDaysForCalculation);
	const workingDaysInPeriod = getWorkingDaysInPeriod(
		new Date(payPeriodDetails.periodStart),
		new Date(payPeriodDetails.periodEnd),
		workingDaysForCalculation,
	);

	const workingDayRatio = workingDaysInPeriod ? daysWorked / workingDaysInPeriod : 0;

	// set default basic hours and salary to reduce client confusion
	const defaultBasicHours = salary.weeklyHours
		? ((((salary.weeklyHours / 40) * 2080) / payPeriodDetails.payPeriods) * workingDayRatio).toFixed(2)
		: 0;
	const defaultBasicPay =
		salaryFrequency == "Month" && payPeriodDetails.payPeriods == 12
			? salaryAmount * workingDayRatio
			: salaryFrequency == "Week" && [52, 26, 13].includes(payPeriodDetails.payPeriods)
			? ((salaryAmount * 52) / payPeriodDetails.payPeriods) * workingDayRatio
			: defaultBasicHours * salary.hourlySalaryAmount;

	const overtimeStartDate =
		payPeriodDetails.previousOvertimeCutOff &&
		format(addDays(new Date(payPeriodDetails.previousOvertimeCutOff), 1), "yyyy-MM-dd");

	const newAllowances = [
		{
			...(basicHoursAllowance || {}),
			id: (basicHoursAllowance && basicHoursAllowance.id) || uuidv4(),
			allowanceType: 277,
			input: basicHoursAllowance
				? basicHoursAllowance.input
				: (index == 0 && employee.payslip && employee.payslip.basicHours) || defaultBasicHours,
			amount: basicHoursAllowance
				? basicHoursAllowance.amount
				: (index == 0 && employee.payslip && employee.payslip.baseSalary) ||
				  (index == 0 && employee?.payslip?.basicHours && defaultBasicHours != employee?.payslip?.basicHours)
				? employee.payslip.basicHours * salary.hourlySalaryAmount
				: defaultBasicPay,
			disabled: !(casual == true || casual == "yes") && !hasMultipleSalaries && !useExactPay, // we need to pull through information on exact pay.
			order: 0,
			isNew: basicHoursAllowance && basicHoursAllowance.id ? false : true,
			// updated: basicHoursAllowance && basicHoursAllowance.id ? false : true,
		},
		...allowancesThisSalary.map((item, index) => ({ ...item, order: index + 20 })),
	];

	salaryAllowances?.map((salaryAllowance, index) => {
		const exists = _.find(
			newAllowances,
			({ allowanceType }) =>
				allowanceType == salaryAllowance.allowanceType || allowanceType == salaryAllowance.type,
		);
		const terminatedPreviousMonths = terminated && salary.end < payPeriodDetails.periodStart;

		const thisAllowance = terminatedPreviousMonths
			? allowanceList.find((i) => i.id == salaryAllowance.allowanceType || i.id == salaryAllowance.type)
			: null;
		const addSalaryAllowance =
			!exists &&
			(!terminatedPreviousMonths ||
				(thisAllowance && ["Hourly", "Basic", "Multiplier"].includes(thisAllowance.method)));

		if (addSalaryAllowance) {
			newAllowances.push({
				id: uuidv4(),
				allowanceType: salaryAllowance.allowanceType || salaryAllowance.type,
				salary: salary.id,
				salaryAllowanceAmount: salaryAllowance.salaryAllowanceAmount || salaryAllowance.amount,
				salaryAllowanceFixed: salaryAllowance.salaryAllowanceFixed,
				salaryAllowance: `${salary.id}.${salaryAllowance.allowanceType || salaryAllowance.type}`,
				order: 1 + index,
				linked: true,
			});
		} else {
			if (exists) {
				// salary allowance amount can be used as input or rate depending on the type
				exists.salaryAllowanceAmount = salaryAllowance?.salaryAllowanceAmount || salaryAllowance?.amount;
				exists.salaryAllowanceFixed = salaryAllowance?.salaryAllowanceFixed;
				exists.salaryAllowance = `${salary.id}.${salaryAllowance.allowanceType || salaryAllowance.type}`;
				exists.order = 1 + index;
			}
		}
	});

	salaryOvertime?.map((salaryOT, index) => {
		if (typeof salaryOT !== "object" && overtimeList) {
			salaryOT = overtimeList?.find((o) => o.id == salaryOT);
			if (salaryOT) {
				salaryOT.overtimeType = salaryOT.id;
			}
		}

		const exists = _.find(
			newAllowances,
			({ allowanceType }) => allowanceType == salaryOT || allowanceType == salaryOT?.overtimeType,
		);
		if (!exists) {
			newAllowances.push({
				allowanceType: typeof salaryOT == "object" ? salaryOT.overtimeType : salaryOT,
				salaryAllowance: typeof salaryOT == "object" ? salaryOT.overtimeType : salaryOT,
				salary: salary.id,
				// order: 2,
				order: 10 + index,
			});
		} else {
			// exists.order = 1;
			exists.order = 10 + index;
			exists.salaryAllowance = typeof salaryOT == "object" ? salaryOT.overtimeType : salaryOT;
		}
	});

	const sortedAllowances = _.orderBy(newAllowances, ["order", "allowanceType"], ["asc", "asc"]);

	const borderLeftStyle = index % 2 == 0 ? "solid 2px black" : "solid 2px #ea611c";

	const periodStartDate = (employee.payslip && employee.payslip.startDate) || payPeriodDetails.periodStart;
	const periodEndDate = (employee.payslip && employee.payslip.EndDate) || payPeriodDetails.periodEnd;

	const startOfSalaryPeriod =
		salaryEffectiveStart &&
		periodStartDate &&
		(salaryEffectiveStart > periodStartDate
			? format(new Date(salaryEffectiveStart), "do MMM")
			: overtimeStartDate && overtimeStartDate < periodStartDate && overtimeStartDate < salaryEffectiveEnd
			? format(new Date(overtimeStartDate), "do MMM")
			: format(new Date(periodStartDate), "do MMM"));

	const endOfSalaryPeriod =
		salaryEffectiveStart &&
		periodStartDate &&
		(salaryEffectiveEnd < periodEndDate && salaryEffectiveEnd != salaryEffectiveStart
			? format(new Date(salaryEffectiveEnd), "do MMM")
			: format(new Date(periodEndDate), "do MMM"));

	return (
		<div>
			{hasMultipleSalaries && (
				<div>
					<strong style={{ marginRight: "10px" }}>
						{startOfSalaryPeriod} - {endOfSalaryPeriod}
					</strong>
					{hasMultiRole ? roleName : salary.employmentTypeName} - {currency}
					{salaryAmount} / {salaryFrequency}
					{overtimeStartDate &&
						overtimeStartDate < periodStartDate &&
						overtimeStartDate < salaryEffectiveEnd && (
							<Tooltip
								content="This salary rate should be used for overtime or any changes that took effect Prior to the change in Salary, as it reflects the period between the last Overtime Cutoff and the change of salary rate."
								styles={{ display: "inline" }}
							>
								<QuestionMarkCircleIcon
									className="h-7 w-7"
									style={{
										display: "inline",
										verticalAlign: "text-top",
									}}
								/>
							</Tooltip>
						)}
				</div>
			)}
			<div style={{ borderLeft: borderLeftStyle, paddingLeft: "5px", marginBottom: "10px" }}>
				<div
					style={{
						display: "grid",
						gridGap: "1.5rem",
						grid: "1.5rem",
						gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
					}}
				>
					<div
						style={{
							gridColumn: "span 4 / span 12",
							lineHeight: "22px",
						}}
					>
						{jurisdiction == "UK" ? "Pay Item" : "Allowance"}/OT
					</div>
					<div
						style={{
							gridColumn: "span 4 / span 12",
							lineHeight: "22px",
						}}
					>
						Input
					</div>
					<div
						style={{
							gridColumn: "span 4 / span 12",
							lineHeight: "22px",
						}}
					>
						Amount
					</div>
					{sortedAllowances &&
						sortedAllowances.length > 0 &&
						sortedAllowances.map((allowance) => (
							<AllowanceRow
								key={allowance.allowanceType}
								allowance={allowance}
								employeeID={employeeID}
								payslipID={employee && employee.payslip && employee.payslip.id}
								ready={ready}
								salary={salary}
								basicHours={basicHoursAllowance && basicHoursAllowance.input}
								unpaidHours={unpaidHoursAllowance && unpaidHoursAllowance.input}
								processedTimesheets={processedTimesheets}
								hasMultipleSalaries={hasMultipleSalaries}
								terminated={terminated}
								engaged={engaged}
							/>
						))}
					<div
						style={{
							gridColumn: "span 12 / span 12",
						}}
					>
						<button
							style={{ lineHeight: "38px" }}
							className="btn btn-xs btn-default add-adjustment"
							type="button"
							data-toggle="tooltip"
							title="Add or Deduct"
							disabled={ready}
							onClick={() => {
								!ready &&
									payrollUpdateAllowance({
										id: uuidv4(),
										isNew: true,
										salary: salary.id,
										employeeID,
									});
							}}
						>
							<PlusIcon
								className="w-6 h-6 mr-3"
								style={{ verticalAlign: "text-bottom" }}
							/>
							Add {jurisdiction == "UK" ? "Pay Item" : "Allowance"}
						</button>

						{!ready && employee?.payslipId && (
							<button
								style={{ lineHeight: "38px" }}
								className="btn btn-xs btn-default add-adjustment right"
								type="button"
								data-toggle="tooltip"
								title="Add or Deduct"
								disabled={ready}
								onClick={() => {
									clearPayslip(employee);
								}}
							>
								<TrashIcon
									className="w-6 h-6 mr-3"
									style={{ verticalAlign: "text-bottom" }}
								/>
								Clear Payslip
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	console.log("state", state && state.grades);
	const employee =
		state.payroll &&
		state.payroll.employees &&
		state.payroll.employees.find((employee) => employee.id == ownProps.employeeID);

	const allowanceList = state.allowances.allowanceList;
	const overtimeList = state?.company?.settings?.overtimes;

	const settings = state.company && state.company?.settings;
	const useExactPay =
		settings?.alwaysExactHours == "yes" ||
		settings?.alwaysExactHours == true ||
		((settings?.exactOnTermination == true || settings?.exactOnTermination == "yes") &&
			(ownProps.engaged || ownProps.terminated)); // && payExactForTerminated || alwaysPayExact

	return {
		employee,
		allowanceList,
		jurisdiction: state.company?.settings?.jurisdiction,
		overtimeList,
		payPeriodDetails: state.payroll && state.payroll.payPeriodDetails,
		useExactPay,
		currency: state?.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	overtimeGetList: () => dispatch(OVERTIMEACTIONS.overtimeGetList()),
	allowanceGetList: () => dispatch(ALLOWANCEACTIONS.allowanceGetList()),
	payrollToggleEmployeeExpand: (employeeID) => dispatch(ACTIONS.payrollToggleEmployeeExpand(employeeID)),
	payrollSaveAllowances: (employeeID, ready) => dispatch(ACTIONS.payrollSaveAllowances(employeeID, ready)),
	payrollUpdateAllowance: (item) => dispatch(ACTIONS.payrollUpdateAllowance(item)),
	clearPayslip: (employee) => dispatch(ACTIONS.showClearPayslipModal(employee)),
	unprocessTimesheetsModal: (agreementID) => dispatch(ACTIONS.unprocessTimesheetsModal(agreementID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryRow);
